import { render } from "./SettingsIcon16.vue.js?vue&type=template&id=96bd3cda!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./SettingsIcon16.vue?vue&type=template&id=96bd3cda"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__